import React, { useEffect, useState, useMemo, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { LoadingOutlined } from "@ant-design/icons";
import { Spin, Pagination } from "antd";

import api from "@/api/index";

import AppHeader from "../components/header/AppHeader";
import FiltersCard from "@/components/filters/FiltersCard";
import FilterHome from "@/components/filters/FIltersHome";
import CardContent from "@/components/card/CardContent";
import Link from "@/components/links/Link";

import "../styles/home.scss";

function Home() {
  const [isLoading, setIsLoading] = useState<boolean>(true);
  const [links, setLinks] = useState([]);
  const [movies, setMovies] = useState([]);
  const [serials, setSerials] = useState([]);
  const [activeType, setActiveType] = useState<string>("movies");
  const [isStart, setIsStart] = useState<boolean>(true)

  const [totalSerials, setTotalSerial] = useState<number>(0);
  const [totalMovies, setTotalMovies] = useState<number>(0);
  const [countMovies, setCountMovies] = useState<number>(0)
  const [countSerials, setCountSerials] = useState<number>(0)

  const [currentPage, setCurrentPage] = useState<number>(1)
  const [isLoadedContent, setIsLoadedContent] = useState<boolean>(false)

  const activeTypeRef = useRef(activeType);


  const RefFilter = useRef(null)

  const [filter, setFilter] = useState<any>({
    search: null,
    year: [],
    categories: [],
    tags: null,
    sort_by: null,
    sort_order: null,
    mine: false,
    sortType: null
  });

  const navigate = useNavigate();

  const onPageChange = (page:number) => {
    setCurrentPage(page)
  }

  const handleAdd = () => {
    navigate("create-content");
  };

  const handleDelete = (index: number) => {
    setLinks((prev) => prev.filter((_, i) => i !== index));

    if (activeType === "movies") {
      fetchMovies(filter);
    } else {
      fetchSerials(filter);
    }
  };

  const handleFilterUpdateOption = async (prop: string, val: any) => {
    const newFilter = {
      ...filter,
      [prop]: val,
    };

    setFilter(newFilter);
    setCurrentPage(1)

    if (activeTypeRef.current === "movies") {
      fetchMovies(newFilter);
    } else {
      fetchSerials(newFilter);
    }
  };

  const onUpdateFilter = (
    type: string | number,
    category: string | number,
    year: number | string,
    status: string | number,
    mine: boolean | null,
    sortType: string | null
  ) => {
    setIsLoading(true);

    showTypeLinks(activeType);

    setTimeout(() => {
      setIsLoading(false);
    }, 500);
  };

  const fetchMovies = async (filters:any = {}, isStart = false) => {
    try {
      setIsLoading(true);

      const { data } = await api.movies.get(filters, currentPage);

      setMovies(data?.data?.movies || []);
      setTotalMovies(data?.data?.pagination?.last_page || 0);
      setCountMovies(data.data.pagination.total)

      if(isStart) {
        setLinks(data?.data?.movies || [])
      }

    } catch (err) {
      console.error(err);
      setLinks([]);
    } finally {
      setIsLoading(false);
    }
  };

  const fetchSerials = async (filters:any = {}) => {
    try {
      setIsLoading(true);
      const { data } = await api.series.getListSeries(filters, currentPage);
      setSerials(data?.data?.series || []);
      setTotalSerial(data?.data?.pagination?.last_page || 0);
      setCountSerials(data.data.pagination.total)
    } catch (err) {
      console.error(err);
      setSerials([]);
    } finally {
      setIsLoading(false);
    }
  };

  const listLinks = useMemo(() => {
    if (activeType === "movies") {
      return movies;
    }

    if (activeType === "serials") {
      return serials;
    }

  }, [movies, serials, links]);

  const totalPages = useMemo(() => {
    return activeType === 'movies' ? totalMovies : totalSerials;

  }, [totalSerials, totalMovies])

  const showTypeLinks = (type: string) => {
    if (type === "movies") {
      setLinks(movies);
      //fetchMovies(filter)
    }

    if (type === "serials") {
      setLinks(serials);
      //fetchSerials(filter)
    }

    setActiveType(type);
    setCurrentPage(1);
  };

  const updateFilterAll = (data) => {
    const updateFilter = {
      search: data.name || null,
      year: data.year || null,
      categories: data.category || null,
      sort_by: data.sort_by || null,
      status: data.status || null,
      mine: data.mine || null,
      sortType: data.sortType || null
    }

    if(isStart) {
      setIsStart(false)

      fetchMovies(updateFilter);
      fetchSerials(updateFilter);

    } else {
      fetchMovies(updateFilter);
      fetchSerials(updateFilter);
    }
  }

  useEffect(() => {
    setTimeout(() => {
      setIsLoadedContent(true)
    }, 2000)
  }, []);

  useEffect(() => {
    if(isLoadedContent) {
      if (activeType === "movies") {
        fetchMovies(filter);
      } else {
        fetchSerials(filter);
      }
    }
  }, [currentPage])

  useEffect(() => {
    activeTypeRef.current = activeType;
  }, [activeType]);

  return (
    <div className="home">
      <AppHeader title="Управление контентом" isLogout={true} />

      <div className="app-container">
        <div className="home__container">
          <div className="home__filters">
            <FiltersCard title="Панель поиска и фильтров">
              <FilterHome
                ref={RefFilter}
                add={handleAdd}

                update={onUpdateFilter}
                updateOption={handleFilterUpdateOption}
                updateFilterAll={updateFilterAll}
              />
            </FiltersCard>
          </div>

          <h6 className="home__container__title">Список контента</h6>

          {isLoading && <Spin size="large" indicator={<LoadingOutlined />} />}

          {!isLoading && (
            <div className="home__container">
              <nav className="home__nav">
                <a
                  onClick={() => showTypeLinks("movies")}
                  className={activeType === "movies" ? "active" : ""}
                >
                  Фильмы ({countMovies})
                </a>
                <a
                  onClick={() => showTypeLinks("serials")}
                  className={activeType === "serials" ? "active" : ""}
                >
                  Сериалы ({countSerials})
                </a>
              </nav>

              {
                  listLinks && listLinks[0] && <div className="home__list">
                    {listLinks.map((link, index) => {
                      return (
                          <div className="home__list__item" key={link.id}>
                            <CardContent title={link.name || link.title}>
                              <Link
                                  data={link}
                                  index={index}
                                  remove={handleDelete}
                                  type={activeType}
                              />
                            </CardContent>
                          </div>
                      );
                    })}
                  </div>
              }

              {
                  listLinks && listLinks[0] && <div className="home__pagination">
                    <Pagination defaultCurrent={currentPage} total={totalPages} onChange={onPageChange} showSizeChanger={false} />
                  </div>
              }
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

export default Home;
